export enum OstiumSubgraphErrorCode {
  INVALID_CONFIG  = 'INVALID_CONFIG',
  INVALID_PARAMS  = 'INVALID_PARAMS',
  FETCH_FAILED    = 'FETCH_FAILED',
  NOT_FOUND       = 'NOT_FOUND',
  PARSE_ERROR     = 'PARSE_ERROR',
}

export class OstiumSubgraphError extends Error {
  constructor(
    message: string,
    public readonly code: OstiumSubgraphErrorCode,
    public readonly cause?: unknown,
  ) {
    super(message);
    this.name = 'OstiumSubgraphError';
  }
}
